module.exports = __webpack_public_path__ + "img/Prenatal.12524f05.png";